import type { ReactNode } from 'react';

export const symbol_hov: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M465.5-111.5Q459-115 454-123L259-449q-5-8-7-15.5t-2-15.5q0-8 2-15.5t7-15.5l195-326q5-8 11.5-11.5T480-852q8 0 14.5 3.5T506-837l195 326q5 8 7 15.5t2 15.5q0 8-2 15.5t-7 15.5L506-123q-5 8-11.5 11.5T480-108q-8 0-14.5-3.5ZM480-197l170-283-170-283-170 283 170 283Zm0-283Z"
		/>
	</svg>
);
